import { useContext, useEffect, useState } from "react";
import { AccrualDto } from "../../../../dtos/catalogs/accrual/AccrualDto";
import { CatalogModalViewHeader } from "../../../Shared/CatalogModalViewHeader";
import { FormProvider, useForm } from "react-hook-form";
import { NewCatalogModalViewContext } from "../../../Shared/NewCatalogModalView";
import AccrualDetailSkeleton from "./AccrualDetailSkeleton";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import AccrualMainDetail from "./AccrualMainDetail";

interface IProps {
  model: AccrualDto | null;
  modelUpdatedEvent: (newModel: AccrualDto) => void;
}

interface AccrualModel {
  name?: string;
  description?: string;
  incomeType?: number;
  uniqueCode?: string;
  createdDate?: string;
  withholdingTaxRateId?: string;
  settlementsAccountId?: string;
  expensesAccountId?: string;
  withholdingTaxId?: string;
  pensionContributionExpenseAccountId?: string;
  pensionContributionAccountId?: string;
  referenceType?: number;
  createdUserId?: string;
  id: string;
}
export const AccrualDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<AccrualModel>();

  const modalViewContext = useContext(NewCatalogModalViewContext);
  const { saveHandler, closeHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (model) {
      setValue("id", model.id);
      setValue("name", model.name);
      setValue("description", model.description);
      setValue("incomeType", model.incomeType);
      setValue("uniqueCode", model.uniqueCode);
      setValue("createdDate", model.createdDate);
      setValue("withholdingTaxRateId", model.withholdingTaxRateId);
      setValue("settlementsAccountId", model.settlementsAccountId);
      setValue("expensesAccountId", model.expensesAccountId);
      setValue("withholdingTaxId", model.withholdingTaxId);
      setValue("pensionContributionExpenseAccountId", model.pensionContributionExpenseAccountId);
      setValue("pensionContributionAccountId", model.pensionContributionAccountId);
      setValue("referenceType", model.referenceType);
      setValue("createdUserId", model.createdUserId);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: AccrualModel) => {
    // return;
    if (action === "save") {
      const newModel: AccrualDto = { ...model, ...data };
      console.log("new model");
      console.log(newModel);
      // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
      await saveHandler(newModel);
    }
    console.log("form submit finish");
  };

  if (!model) {
    return (
      <>
        <AccrualDetailSkeleton />
      </>
    );
  }

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
        </NFTabs>

        <CatalogModalViewHeader onSave={handleSubmit((data) => handleFormSubmit("save", data))} onClose={closeHandler} />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <AccrualMainDetail />
        </NFTabContainer>
      </FormProvider>
    </>
  );
};
